import React from 'react'
import type { UnsavedFormProps } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ExitUnsavedFormsContext = React.createContext<UnsavedFormProps<any> | undefined>(undefined)
